import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import SEO from "../utils/seo";

function Team() {
  const servicesColumns = [
    {
      column: "left",
      services: [
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune to Mumbai",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Mumbai to Pune",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune Airport to Mumbai",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Mumbai Airport to Pune",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune to Shirdi",
        },
      ],
    },
    {
      column: "right",
      services: [
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Mumbai to Shirdi",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune Airport to Shirdi",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Mumbai Airport to Shirdi",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune to Nashik",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Mumbai to Nashik",
        },
      ],
    },
    {
      column: "left",
      services: [
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune All Local",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune to Pune Airport",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune to Pune Station",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune to Pune Darshan",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune to Solapur",
        },
      ],
    },
    {
      column: "right",
      services: [
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Solapur to Pune",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune to Akkalkot Darshan",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune to Tuljapur Darshan",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune to Gujarat",
        },
        {
          href: "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
          text: "Pune to indore",
        },
      ],
    },
  ];
  return (
    <>
      <section className="team-page">
        <SEO
          title="MyDearCab - Top Cab Services in Pune"
          description="Book Pune to Mumbai cab at lowest fare. Clean cars, safe drivers, airport pickup & drop, 24/7 service. Sedan, SUV, Innova available. WhatsApp Booking: 8007722929."
          keywords="taxi service in pune,pune cab booking,pune airport cab service,pune airport pickup and drop,local taxi pune,online cab booking pune, pune to shirdi cab,pune to nashik cab,pune to aurangabad cab,pune to kolhapur cab,pune to goa cab,pune to mahabaleshwar cab,pune to mumbai taxi,pune to mumbai one way cab,pune to mumbai drop taxi,pune to mumbai car rental, pune to mumbai taxi lowest fare,pune to mumbai cab price,pune to mumbai cheap cab,pune to mumbai budget taxi,24 hours pune to mumbai cab,safe pune to mumbai cab for family,pune to mumbai airport drop cab,pune to mumbai sedan cab,pune to mumbai suv cab, pune airport to mumbai cab,hinjewadi to mumbai cab,swargate to mumbai cab,wakad to mumbai cab, pune to mumbai cab one way at affordable fare,pune to mumbai taxi service with driver,book pune to mumbai cab on whatsapp, pune to mumbai cab,pune to mumbai taxi,pune to mumbai one way cab,pune to mumbai one way taxi,pune to mumbai cab fare,pune to mumbai airport drop taxi,pune to mumbai online cab booking, Pune to Mumbai Cab | One Way Taxi | Lowest Fare | 24×7 Service, Near me cab service, Near me taxi service, Near me car rental services"
          canonicalUrl="https://www.mydearcab.com/team"
        />
        <HeroPages name="Our Services" />
        <div className="container">
          <div className="team-container">
            {servicesColumns.map((column, colIndex) => (
              <div
                key={colIndex}
                className={`services-column services-column--${column.column}`}
              >
                <div className="services-column__container">
                  <ul className="services-list">
                    {column.services.map((service, serviceIndex) => (
                      <li className="services-list__item" key={serviceIndex}>
                        <a href={service.href} className="services-list__link">
                          <span className="services-list__icon">
                            <i
                              aria-hidden="true"
                              className="fas fa-car-side"
                            ></i>
                          </span>
                          <span className="services-list__text">
                            {service.text}
                          </span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2>Book a cab by getting in touch with MyDearCab</h2>
              <span>
                <i className="fa-solid fa-phone"></i>
                <h3>+91 8007722929</h3>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Team;
